module.exports = __webpack_public_path__ + "static/media/PDF_122.e21f699f.pdf";